import { render } from "./view-product.vue?vue&type=template&id=1442bb84&scoped=true"
import script from "./view-product.vue?vue&type=script&lang=js"
export * from "./view-product.vue?vue&type=script&lang=js"

import "./view-product.vue?vue&type=style&index=0&id=1442bb84&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1442bb84"]])

export default __exports__